import { LatestLessonsPageSection } from "../../models/page-builder/latest-lessons.model";

export const MOCK_LATEST_LESSONS: LatestLessonsPageSection = {
  type: "latest-lessons",
  content: {
    headings: {
      title: "Latest Lessons",
      titleColor: "#ffffff",
      subtitle: "Stay up to date with the latest lessons.",
      subTitleColor: "#f1f1f1",
    },
    lessons: {
      showCourseCover: true,
      numberOfLessonsToBeDisplayed: 7,
    },
  },
  design: {
    layout: {
      blockStyle: "card",
      headingAlignment: "center",
    },
    appearance: {
      cardBackgroundColor: "#6F8FAF",
      backgroundColor: "#999999",
    },
  },
};
